module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "paid-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "paid-center-right"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/paid-information-title?id=0"
    }
  }, [_vm._v("【付费资讯】下沉市场不需要巨头，但很需要社区团购"), _c('span', {
    staticClass: "red"
  }, [_vm._v("（收费：1元/次）")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/paid-information-title?id=1"
    }
  }, [_vm._v("【付费资讯】中国制造网“三月采购节”启动 推出直播带货等活动"), _c('span', {
    staticClass: "red"
  }, [_vm._v("（收费：1元/次）")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/paid-information-title?id=2"
    }
  }, [_vm._v("【付费资讯】两会后电商新时代！透露出哪些新经济趋势？"), _c('span', {
    staticClass: "red"
  }, [_vm._v("（收费：1元/次）")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/paid-information-title?id=3"
    }
  }, [_vm._v("【付费资讯】2021年中国互联网发展趋势"), _c('span', {
    staticClass: "red"
  }, [_vm._v("（收费：1元/次）")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/paid-information-title?id=4"
    }
  }, [_vm._v("【付费资讯】2021年互联网行业展望：全面拥抱数字时代"), _c('span', {
    staticClass: "red"
  }, [_vm._v("（收费：1元/次）")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/paid-information-title?id=5"
    }
  }, [_vm._v("【付费资讯】5G技术能为智能制造赋能哪些？"), _c('span', {
    staticClass: "red"
  }, [_vm._v("（收费：1元/次）")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paid-header"
  }, [_c('div', {
    staticClass: "paid-header-dw"
  }, [_c('div', {
    staticClass: "paid-header-tit"
  }, [_vm._v("付费资讯中心")]), _vm._v(" "), _c('div', {
    staticClass: "paid-header-search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入搜索内容"
    }
  }), _vm._v(" "), _c('button', [_vm._v("搜索")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("付费资讯")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73d8897d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/paid-information/index.vue
// module id = 1637
// module chunks = 1